export default "__VITE_ASSET__a2afb1d8__"